<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-header">
        <div>
          <h3 class="card-title">{{ "IMPORT_ASSETS" | translate }}</h3>
        </div>
        <div *ngIf="xlsx_file_content">
          <a class="btn btn-outline-secondary text-secondary mr-2" (click)="xlsx_file_content = null">{{ "RESET" | translate }}</a>
          <a class="btn btn-outline-primary text-primary" (click)="save()" *ngIf="_authenticationService.hasCapability('asset_import')">{{ "IMPORT" | translate }}</a>
        </div>
      </div>
      <div class="card-body">
        <div *ngIf="!xlsx_file_content" class="row">
          <div class="col-xl-4">
            <div class="custom-file">
              <input class="custom-file-input" type="file" lang="it" id="resignation-upload" accept="application/vnd.sealed.xls" (change)="handlerChangeFileInput($event)" />
              <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
            </div>
          </div>
          <div class="col-md-12">
            <p class="font-small-2 mt-1 mb-0">
              {{ "DOWNLOAD_TEMPLATE_FILE_FROM_HERE" | translate }} <a (click)="downloadTemplate()" class="text-primary">{{ "DOWNLOAD_IT_HERE" | translate }}</a
              >.
            </p>
          </div>
        </div>
        <div *ngIf="xlsx_file_content">
          <div class="mb-1">{{ "PROCESSED_ITEMS" | translate }}: {{ processedItems() }} / {{ xlsx_file_content.length }}</div>

          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [rows]="xlsx_file_content" [headerHeight]="50" [scrollbarV]="true" [scrollbarH]="false" [rowHeight]="70" [limit]="20" [footerHeight]="50">
            <ngx-datatable-column [name]="'INTERNAL_SERIAL' | translate" prop="serial" [sortable]="true">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.serial }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CATEGORY' | translate" prop="category_name" [sortable]="true">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.category_name }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.name }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRODUCT_SERIAL_NUMBER' | translate" prop="product_serial_number" [sortable]="true">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.product_serial_number }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CONTRACT' | translate" prop="contract" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.contract }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CONTRACT_END_DATE' | translate" prop="contract_end_date" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.contract_end_date }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'END_LICENSE' | translate" prop="license_end_date" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.license_end_date }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'STATUS.STATUS' | translate" prop="" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-light-secondary text-dark" *ngIf="row.status === 0">{{ "STATUS.PENDING" | translate }}</span>
                <span class="badge badge-light-warning text-dark" *ngIf="row.status === 1">{{ "STATUS.PROCESSING" | translate }}</span>
                <span class="badge badge-light-success text-dark" *ngIf="row.status === 2">{{ "STATUS.COMPLETED" | translate }}</span>
                <span class="badge badge-light-danger text-dark" *ngIf="row.status === 3">{{ "STATUS.ERROR" | translate }}</span>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </div>
  </div>
</div>
